import { render, staticRenderFns } from "./CardContainerMain.vue?vue&type=template&id=e85fead6&scoped=true&"
import script from "./CardContainerMain.vue?vue&type=script&lang=js&"
export * from "./CardContainerMain.vue?vue&type=script&lang=js&"
import style0 from "./CardContainerMain.vue?vue&type=style&index=0&id=e85fead6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85fead6",
  null
  
)

export default component.exports